import React from "react"
import AllMenus from "../components/collections/Menus"
import FooterSection from "./FooterSection"

export default function FooterMenu({ className, menuName, pageLink }) {
  const allMenus = AllMenus()

  let menu = null
  allMenus.nodes.forEach(m => {
    if (menuName === m.slug) {
      menu = m
    }
  })
  return (menu && (
<FooterSection
      className={className}
      header={menu.name}
      headerLink={pageLink}
      items={menu.menuItems?.nodes}
    />
  ))
}
